import { MessageTemplateStatus } from "#resources/api/enterprise-generated";

export const modalMyModels = {
	title: "Meus modelos",
	columns: {
		model: "Modelo",
		status: "Status",
	},
	status: {
		approved: "Aprovado",
		pending: "Processando",
		received: "Recebido",
		rejected: "Recusado",
	} as Record<MessageTemplateStatus, string>,
	emptyState: {
		title: "Nenhum template cadastrado",
		text:
			"Solicite um novo template para enviar o mensagens de WhatsApp para seus clientes",
	},
	requestNewModel: "Solicitar novo modelo",
};
